"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFocus = trackFocus;
const browser_core_1 = require("@datadog/browser-core");
const types_1 = require("../../../types");
function trackFocus(configuration, focusCb) {
    return (0, browser_core_1.addEventListeners)(configuration, window, ["focus" /* DOM_EVENT.FOCUS */, "blur" /* DOM_EVENT.BLUR */], () => {
        focusCb({
            data: { has_focus: document.hasFocus() },
            type: types_1.RecordType.Focus,
            timestamp: (0, browser_core_1.timeStampNow)(),
        });
    });
}
//# sourceMappingURL=trackFocus.js.map